import { createContext } from 'react';
import { CreateDataRoomShareableLinkTemplate } from 'models/ShareableLink';
import utils from 'utils';

type CreateShareableLinkContextProps = {
  openCreateShareableLink: (filesId?: string[]) => void;
  openCreateShareableLinkWithTemplate: (
    link: CreateDataRoomShareableLinkTemplate,
    onBack?: () => void,
  ) => void;
};

export default createContext<Partial<CreateShareableLinkContextProps>>({
  openCreateShareableLink: utils.noop,
  openCreateShareableLinkWithTemplate: utils.noop,
});
